import { StorageKeys } from "constants/storage-keys";

import { FeatureConfig, getOrgFeatureConfigs } from "./featureConfigApi";

const defaultFeatureConfig: Record<FeatureConfig, boolean> = {
	[FeatureConfig.dashboard]: true,
	[FeatureConfig.usersFunnel]: false,
	[FeatureConfig.employeesManagement]: false,
	[FeatureConfig.buddy]: false,
	[FeatureConfig.inGameChatGPT]: true,
	[FeatureConfig.knowledgeSources]: false,
	[FeatureConfig.storyBuilder]: false,
	[FeatureConfig.roomTemplates]: false,
	[FeatureConfig.employeeJourneys]: false,
	[FeatureConfig.createRoom]: false,
	[FeatureConfig.goalSettings]: false,
	[FeatureConfig.questionnaire]: false,
	[FeatureConfig.creditsOverview]: false,
	[FeatureConfig.events]: false,
	[FeatureConfig.widget]: false,
	[FeatureConfig.task]: false,
};

let featureConfig: Record<FeatureConfig, boolean> | null = defaultFeatureConfig;

/**
 * Initialize feature config
 */
export const initFeatureConfig = async () => {
	try {
		featureConfig = await getOrgFeatureConfigs();
		localStorage.setItem(StorageKeys.FEATURE_CONFIG, JSON.stringify(featureConfig));
	} catch (err) {
		console.error("Failed to fetch feature config", err);
		const storedFeatureConfig = localStorage.getItem(StorageKeys.FEATURE_CONFIG);
		if (storedFeatureConfig) {
			featureConfig = JSON.parse(storedFeatureConfig);
		}
	}
};

/**
 * Get feature config by feature name
 *
 * @param feature
 * @returns
 */
export const isFeatureEnabled = (feature: FeatureConfig) => {
	try {
		const storedFeatureConfig = localStorage.getItem(StorageKeys.FEATURE_CONFIG);
		if (storedFeatureConfig) {
			featureConfig = JSON.parse(storedFeatureConfig);
		}
	} catch (err) {
		console.error("Failed to get feature config", err);
	}
	if (!featureConfig) {
		return false;
	}
	return featureConfig[feature];
};
